import { apiClient } from './apiClient';

export type EmailOutboxStatus =
  | 'Pending'
  | 'Processing'
  | 'Sent'
  | 'Failed'
  | 'Cancelled';

export type EmailOutboxItem = {
  id: string;
  toAddress: string;
  subject: string;
  status: EmailOutboxStatus | string;
  attemptCount: number;
  maxAttempts: number;
  nextAttemptAtUtc: string;
  lastError?: string | null;
  sentAtUtc?: string | null;
  correlationType?: string | null;
  correlationId?: string | null;
  emailTemplateId?: string | null;
  emailTemplateName?: string | null;
  createdAtUtc: string;
  updatedAtUtc: string;
};

export type EmailOutboxListResult = {
  items: EmailOutboxItem[];
  totalCount: number;
  page: number;
  pageSize: number;
};

export async function listEmailOutbox(params?: {
  status?: string;
  search?: string;
  page?: number;
  pageSize?: number;
}): Promise<EmailOutboxListResult> {
  const response = await apiClient.get<EmailOutboxListResult>('/v1/email-outbox', {
    params: {
      status: params?.status || undefined,
      search: params?.search || undefined,
      page: params?.page ?? 1,
      pageSize: params?.pageSize ?? 20,
    },
  });
  return response.data;
}

export async function cancelEmailOutbox(id: string): Promise<void> {
  await apiClient.post(`/v1/email-outbox/${id}/cancel`);
}

export async function resendEmailOutbox(id: string): Promise<void> {
  await apiClient.post(`/v1/email-outbox/${id}/resend`);
}

export async function deleteEmailOutbox(id: string): Promise<void> {
  await apiClient.delete(`/v1/email-outbox/${id}`);
}
